import { HostMode, HostType } from '@repo/types/host';

export function isStandaloneWebMapHost(
    hostType: HostType | string | undefined,
    hostMode: HostMode | string | undefined,
): boolean {
    const type = hostType ?? HostType.WEB;
    const mode = hostMode ?? HostMode.WINDOW;
    return type === HostType.WEB && mode === HostMode.WINDOW;
}
